export const MENU_ITEM_CLICK = 'MENU_ITEM_CLICK';

export const menuItemClick = (tag) => ({
  type: MENU_ITEM_CLICK,
  payload: tag,
});
